import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/shared/lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-24" data-testid="forgot-password-page">
      <div className="label-xs text-[#ed6500] mb-6">Password reset</div>
      <h1 className="font-serif font-light text-5xl leading-[0.95] tracking-tighter mb-6">Forgot password?</h1>
      <p className="text-[#515E7B] mb-10">No worries — enter your email and we'll send you a link to reset it.</p>

      {sent ? (
        <div className="border hairline bg-white p-8 space-y-3" data-testid="forgot-password-sent">
          <div className="label-xs text-[#5c97f7]">Check your email</div>
          <div className="font-serif text-2xl">Reset link sent.</div>
          <p className="text-sm text-[#515E7B]">If an account exists for <span className="text-[#0A1128] font-semibold">{email}</span>, a reset link is on its way. The link expires in 30 minutes.</p>
          <div className="pt-3">
            <Link to="/login" className="text-[11px] tracking-widest uppercase text-[#ed6500] hover:underline">Back to sign in</Link>
          </div>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-8">
          <div>
            <div className="label-xs mb-3">Email</div>
            <input className="input-line" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email"/>
          </div>
          <button disabled={busy} className="btn-primary text-xs tracking-widest uppercase disabled:opacity-60" data-testid="forgot-submit">
            {busy ? "Sending…" : "Send reset link"}
          </button>
        </form>
      )}
      <div className="mt-8 label-xs text-[#515E7B]">
        Remembered it? <Link to="/login" className="text-[#ed6500] hover:underline">Sign in</Link>
      </div>
    </div>
  );
}
